import { render, staticRenderFns } from "./NgListItem.vue?vue&type=template&id=4c50fed0&scoped=true&"
import script from "./NgListItem.vue?vue&type=script&lang=js&"
export * from "./NgListItem.vue?vue&type=script&lang=js&"
import style0 from "./NgListItem.vue?vue&type=style&index=0&id=4c50fed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c50fed0",
  null
  
)

export default component.exports